import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
// import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { Observable } from '../../../../node_modules/rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()

export class SearchTermservice {
    states;
    loginId;
    url = environment.configURI;
    // private agentDetails = "/agent";
    private agentDetails = "/vendor/";
    private clientVendorDetails = "/client/vendor/";
    private statesList = "/states";
    private vendorSummary = '/vendor/';
    private summaryAPI = '/info';
    searchdDash;

    // httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };

    // httpHeaderOptions = {
    //   headers: new Headers({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };

    constructor(private http: Http,
        private httpClient: HttpClient,
        public userFriendlyMsgs: UserFriendlyMsgs) {
        this.searchdDash = new Subject();
        this.states = new BehaviorSubject('1');
    }

    agentSearch(agentName, region, stateCode, postalCode, agentid) {
        // this.httpClientHeaderOptions = {
        //   headers: new HttpHeaders({
        //     'x-access-token': localStorage.getItem('Token'),
        //     'Cache-Control': 'no-cache',
        //     'Pragma': 'no-cache',
        //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        //   })
        // };
        //this.httpClientHeaderOptions.headers = this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
        if (region === 'Select a Region') {
            region = '';
        } else { }
        if (stateCode === 'Select a State') {
            stateCode = '';
        } else { }
        const body = {
            vendorname: agentName,
            vendor_id: agentid,
            region: region,
            postalcode: postalCode,
            state: stateCode
        };
        let role = parseInt(localStorage.getItem("RoleVal"))
        if (role === 8) {
            return this.httpClient.post(this.url + '/client/vendor/search', body).catch(this.userFriendlyMsgs.errorHandler);
        }
        else {
            return this.httpClient.post(this.url + '/vendor/search', body).catch(this.userFriendlyMsgs.errorHandler);
        }
    }

    detailsOfAgent(agentId) {
        // this.httpClientHeaderOptions = {
        //   headers: new HttpHeaders({
        //     'x-access-token': localStorage.getItem('Token'),
        //     'Cache-Control': 'no-cache',
        //     'Pragma': 'no-cache',
        //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        //   })
        // };
        //this.httpClientHeaderOptions.headers = this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
        let role = parseInt(localStorage.getItem("RoleVal"))
        if (role === 8) {
            return this.httpClient.get(`${this.url}${this.clientVendorDetails}${agentId}`).catch(this.userFriendlyMsgs.errorHandler);
        } else {
            return this.httpClient.get(`${this.url}${this.agentDetails}${agentId}`).catch(this.userFriendlyMsgs.errorHandler);
        }
    }

    getListOfStates(): Observable<any> {
        // this.httpClientHeaderOptions = {
        //   headers: new HttpHeaders({
        //     'x-access-token': localStorage.getItem('Token'),
        //     'Cache-Control': 'no-cache',
        //     'Pragma': 'no-cache',
        //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        //   })
        // };
        //this.httpClientHeaderOptions.headers = this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
        return this.httpClient.get(`${this.url}${this.statesList}`).catch(this.userFriendlyMsgs.errorHandler);
    }

    saveAdditionalAgent(data) {
        // this.httpClientHeaderOptions = {
        //   headers: new HttpHeaders({
        //     'x-access-token': localStorage.getItem('Token'),
        //     'Cache-Control': 'no-cache',
        //     'Pragma': 'no-cache',
        //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        //   })
        // };
        //this.httpClientHeaderOptions.headers = this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
        this.loginId = localStorage.getItem('loginID');
        const body = {
            "_id": data._id,
            "legalname": data.legal_name,
            "dba": data.dba,
            "dateincorporated": data.incorporated_dtm,
            "stateincorporated": data.state_incorporated_dtm,
            "vendorstatus": data.vendor_status === true ? 'Y' : 'N',
            "holdstatus": data.hold_status === true ? 'Y' : 'N',
            "websiteurl": data.website_url,
            "taxidtype": data.taxId,
            "taxidnumber": data.taxId_number,
            "totaltrucks": data.total_tow_trucks_owned,
            "flatbed": data.flatbed_flg == true ? 'Y' : 'N',
            "impoundservice": data.impoundservice_flg === true ? 'Y' : 'N',
            "heavydutyservice": data.heavydutyservice_flg === true ? 'Y' : 'N',
            "indoorstorage": data.indoor_storage_available === true ? 'Y' : 'N',
            "reposoftware": data.repo_software,
            "repoassociation1": data.repo_association_1,
            "repoassociation2": data.repo_association_2,
            "lpr": data.lpr,
            "gps": data.gps,
            "womenownedbusiness": data.women_owned === true ? 'Y' : 'N',
            "minorityownedbusiness": data.minority_owned === true ? 'Y' : 'N',
            "platinumcompliance": data.platinum_compliant === true ? 'Y' : 'N',
            "created_by": this.loginId,
            "updated_by": this.loginId
        }
        return this.httpClient.post(`${this.url}${this.vendorSummary}${data.MasterVendorId}${this.summaryAPI}`, body).catch(this.userFriendlyMsgs.errorHandler);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/search/search-service.service.ts